import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {RoundOfQuestionsSearch} from '../../../models/round-of-questions-search.interface';

@Component({
  selector: 'app-round-of-questions-filter',
  templateUrl: './round-of-questions-filter.component.html',
  styleUrls: ['./round-of-questions-filter.component.scss']
})
export class RoundOfQuestionsFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    year: [],
    name: [''],
    isLaunch: [],
    startLaunched: [''],
    endLaunched: [''],
    status: ['ACTIVE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get nameControl(): FormControl {
    return this.searchForm.get('name') as FormControl;
  }
  get isLaunchControl(): FormControl {
    return this.searchForm.get('isLaunch') as FormControl;
  }
  get startLaunchedControl(): FormControl {
    return this.searchForm.get('startLaunched') as FormControl;
  }
  get endLaunchedControl(): FormControl {
    return this.searchForm.get('endLaunched') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Output()
  search: EventEmitter<RoundOfQuestionsSearch> = new EventEmitter<RoundOfQuestionsSearch>();

  constructor(private formBuilder: FormBuilder,
              private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: RoundOfQuestionsSearch = {
      year: this.yearControl.value,
      name: this.nameControl.value,
      launched: this.isLaunchControl.value,
      startLaunched: this.datePipe.transform(this.startLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      endLaunched: this.datePipe.transform(this.endLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
